import { createSelector } from '@reduxjs/toolkit';
import { computersForMap } from './computers-for-map';

export const computersOnNhn = createSelector(computersForMap, (computers) =>
  computers.filter(function (c) {
    return (
      c.unitType !== 'computer' &&
      c.unitType !== '' &&
      c.unitType !== 'printer' &&
      (c.connectionType === 'NHN' || c.connectionType === 'NHNotherISP')
    );
  }),
);
